import React from "react";
import { NavLinks } from "../../components";
import "./SideNav.css";

const SideNav = () => {
    return (
        <div className="lul__sideNav">
            <NavLinks />
        </div>
    );
};

export default SideNav;
